import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ChatCtaCard() {
  const navigate = useNavigate();
  return (
    <div className="calmleaf-section">
      <h3>Got any questions? Ask the trainer</h3>
      <p style={{ marginTop: 4, color: 'rgba(255, 255, 255, 0.72)' }}>
        24/7 training and coaching support at your fingertips
      </p>
      <button onClick={() => navigate('/chat')}>Chat Now</button>
    </div>
  );
}
